import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate, useLocation } from 'react-router-dom'
import './styles/main.css'
import Login from './pages/Login'
import SoporteTecnico from './pages/SoporteTecnico'
import Mantenimiento from './pages/Mantenimiento'
import VentaEquipos from './pages/VentaEquipos'
import Alquiler from './pages/Alquiler'
import Contacto from './pages/Contacto'

function AppContent() {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [navbarScrolled, setNavbarScrolled] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: 'Me gustaría recibir información sobre sus servicios y precios.'
  });
  const [submitStatus, setSubmitStatus] = useState({ show: false, message: '', type: '' });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setNavbarScrolled(window.scrollY > 50);
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const testimonios = [
    {
      texto: "Excelente servicio de soporte técnico. Resolvieron mi problema rápidamente y de manera profesional.",
      autor: "Carlos Martínez",
      cargo: "Gerente de TI, Empresa XYZ"
    },
    {
      texto: "El mantenimiento preventivo ha mejorado significativamente el rendimiento de nuestros equipos.",
      autor: "Ana Rodríguez",
      cargo: "Directora de Operaciones, ABC Corp"
    },
    {
      texto: "La calidad de los equipos que nos proporcionaron ha superado nuestras expectativas.",
      autor: "Juan Pérez",
      cargo: "CEO, Startup Innovación"
    }
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonios.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedIn);
  }, []);

  const handleLogin = () => {
    localStorage.setItem('isLoggedIn', 'true');
    setIsLoggedIn(true);
    navigate('/');
  };

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false);
    navigate('/');
  };

  const handleRentalClick = () => {
    navigate('/alquiler');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Limpiar el error cuando el usuario comienza a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});

    // Validación básica
    const newErrors = {};
    if (!formData.nombre.trim()) newErrors.nombre = 'El nombre es requerido';
    if (!formData.email.trim()) {
      newErrors.email = 'El correo electrónico es requerido';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'El correo electrónico no es válido';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitting(false);
      return;
    }

    try {
      // ENVÍA LOS DATOS AL WEB APP DE GOOGLE SHEETS
      const response = await fetch('https://script.google.com/macros/s/AKfycbxM25T7LyVuEy9lW68d_jr-K1Jd6Ja9ct5P1BMypDoBYSJrl9Z93QJa01XWUINdDz7i4A/exec', {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();

      if (result.result === 'success') {
        setSubmitStatus({
          show: true,
          message: '¡Gracias por contactarnos! Nos pondremos en contacto contigo pronto.',
          type: 'success'
        });
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          mensaje: 'Me gustaría recibir información sobre sus servicios y precios.'
        });
      } else {
        throw new Error(result.message || 'Error al guardar los datos');
      }
    } catch (error) {
      setSubmitStatus({
        show: true,
        message: 'Hubo un error al enviar el formulario. Por favor, inténtalo de nuevo.',
        type: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app">
      <nav className={`navbar ${navbarScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-content">
          <Link to="/" className="logo">
            <img src="/images/logo.png" alt="Lycan Systems" className="logo-img" />
            <div className="logo-text">
              <div className="logo-title">Lycan Systems S.A.S</div>
              <div className="logo-subtitle">Soluciones en Tecnología</div>
            </div>
          </Link>
          <div className="nav-links">
            <Link to="/" className="nav-link">Inicio</Link>
            {isLoggedIn ? (
              <>
                <Link to="/" className="nav-link" onClick={handleRentalClick}>Dashboard</Link>
                <button onClick={handleLogout} className="logout-button">
                  <span className="material-icons">logout</span>
                  Cerrar Sesión
                </button>
              </>
            ) : null}
          </div>
        </div>
      </nav>

      <Routes>
        <Route path="/" element={
          <div className="main-content">
            {/* Servicios Section */}
            <section id="servicios" className="services">
              <div className="container">
                <div className="section-title">
                  <h2>Nuestros Servicios</h2>
                </div>
                <div className="services-grid">
                  <Link to="/soporte-tecnico" className="service-card">
                    <img 
                      src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                      alt="Soporte Técnico" 
                      className="service-image"
                    />
                    <div className="service-content">
                      <h3>Soporte Técnico</h3>
                      <p>Asistencia técnica especializada para mantener tus sistemas funcionando</p>
                    </div>
                  </Link>
                  <Link to="/mantenimiento" className="service-card">
                    <img 
                      src="https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                      alt="Mantenimiento" 
                      className="service-image"
                    />
                    <div className="service-content">
                      <h3>Mantenimiento</h3>
                      <p>Mantenimiento preventivo y correctivo de computadores para garantizar su óptimo funcionamiento.</p>
                    </div>
                  </Link>
                  <Link to="/venta-equipos" className="service-card">
                    <img 
                      src="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2026&q=80" 
                      alt="Venta de Equipos" 
                      className="service-image"
                    />
                    <div className="service-content">
                      <h3>Venta de Equipos</h3>
                      <p>Venta de computadores, periféricos, cámaras de CCTV y licencias de software Office.</p>
                    </div>
                  </Link>
                  <div className="service-card" onClick={handleRentalClick} style={{ cursor: 'pointer' }}>
                    <img 
                      src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                      alt="Alquiler de Equipos" 
                      className="service-image"
                    />
                    <div className="service-content">
                      <h3>Alquiler de Equipos</h3>
                      <p>Alquiler de equipos de cómputo para uso empresarial, con opciones flexibles y personalizadas.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Testimonios Section */}
            <section id="testimonios" className="testimonials">
              <div className="container">
                <div className="section-title">
                  <h2>Lo que dicen nuestros clientes</h2>
                </div>
                <div className="testimonials-container">
                  <div className="testimonials-slider">
                    {testimonios.map((testimonio, index) => (
                      <div 
                        key={index}
                        className={`testimonial-slide ${index === currentSlide ? 'active' : ''}`}
                      >
                        <p className="testimonial-text">"{testimonio.texto}"</p>
                        <p className="testimonial-author">- {testimonio.autor}</p>
                        <p className="testimonial-position">{testimonio.cargo}</p>
                      </div>
                    ))}
                  </div>
                  <div className="testimonial-dots">
                    {testimonios.map((_, index) => (
                      <div
                        key={index}
                        className={`testimonial-dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* Contacto Section */}
            <section id="contacto" className="contact">
              <div className="container">
                <div className="section-title">
                  <h2>Contáctanos</h2>
                  <p>Estamos aquí para ayudarte. Elige la forma más conveniente para comunicarte con nosotros.</p>
                </div>
                <div className="contact-methods">
                  <div className="contact-method">
                    <div className="method-content">
                      <span className="material-icons">email</span>
                      <h3>Email</h3>
                      <p>gerenciait@lycansystems.com.co</p>
                      <a href="mailto:gerenciait@lycansystems.com.co" className="contact-btn">
                        <span className="material-icons">send</span>
                        Enviar correo
                      </a>
                    </div>
                  </div>
                  <div className="contact-method">
                    <div className="method-content">
                      <span className="material-icons">message</span>
                      <h3>WhatsApp</h3>
                      <p>+57 311 261 0669</p>
                      <a href="https://wa.me/573112610669" className="contact-btn" target="_blank" rel="noopener noreferrer">
                        <span className="material-icons">send</span>
                        Enviar mensaje
                      </a>
                    </div>
                  </div>
                </div>
                <div className="contact-form-container">
                  <div className="form-intro">
                    <h3>¿Prefieres que te contactemos?</h3>
                    <p>Déjanos tus datos y nos pondremos en contacto contigo lo antes posible.</p>
                  </div>
                  <form className="contact-form" onSubmit={handleSubmit}>
                    {submitStatus.show && (
                      <div className={`submit-message ${submitStatus.type}`}>
                        {submitStatus.message}
                      </div>
                    )}
                    <div className="form-group">
                      <label htmlFor="nombre">Nombre completo *</label>
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        className={errors.nombre ? 'error' : ''}
                      />
                      {errors.nombre && <span className="error-message">{errors.nombre}</span>}
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Correo electrónico *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className={errors.email ? 'error' : ''}
                      />
                      {errors.email && <span className="error-message">{errors.email}</span>}
                    </div>
                    <div className="form-group">
                      <label htmlFor="telefono">Teléfono</label>
                      <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        value={formData.telefono}
                        onChange={handleChange}
                        placeholder="+57 300 123 4567"
                        className={errors.telefono ? 'error' : ''}
                      />
                      {errors.telefono && <span className="error-message">{errors.telefono}</span>}
                    </div>
                    <div className="form-group">
                      <label htmlFor="mensaje">Mensaje</label>
                      <textarea
                        id="mensaje"
                        name="mensaje"
                        value={formData.mensaje}
                        onChange={handleChange}
                        rows="3"
                      ></textarea>
                    </div>
                    <button type="submit" className="submit-btn" disabled={isSubmitting}>
                      {isSubmitting ? (
                        <>
                          <span className="material-icons loading">refresh</span>
                          Enviando...
                        </>
                      ) : (
                        <>
                          <span className="material-icons">send</span>
                          Enviar datos
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </section>
          </div>
        } />
        <Route path="/login" element={
          isLoggedIn ? (
            <Navigate to="/" replace />
          ) : (
            <Navigate to="/" replace />
          )
        } />
        <Route path="/soporte-tecnico" element={<SoporteTecnico />} />
        <Route path="/mantenimiento" element={<Mantenimiento />} />
        <Route path="/venta-equipos" element={<VentaEquipos />} />
        <Route path="/alquiler" element={<Alquiler />} />
        <Route path="/contacto" element={<Contacto />} />
      </Routes>

      <footer className="footer">
        <div className="footer-content">
          <p>&copy; 2024 Lycan System. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  )
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App 